// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8e43886d","667":"221ba0ce"}[chunkId] + ".chunk.js";
};